import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
export function About() {
  const benefits = ['Atención cercana y humana', 'Experiencia en lectura energética', 'Orientación personalizada', 'Sesiones presenciales y remotas', 'Compromiso con tu bienestar'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative z-10 bg-mystic-black/50 border-y border-mystic-gold/10" data-id="element-15">
      <div className="max-w-7xl mx-auto" data-id="element-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-17">
          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative" data-id="element-18">
            <div className="absolute inset-0 bg-mystic-gold/10 rounded-3xl transform -rotate-3 scale-105" data-id="element-19"></div>
            <div className="absolute inset-0 bg-mystic-blue-900/30 rounded-3xl transform rotate-2 scale-105 backdrop-blur-sm" data-id="element-20"></div>
            <div className="relative rounded-3xl overflow-hidden border border-mystic-gold/30 shadow-2xl" data-id="element-21">
              <img src="https://cdn.magicpatterns.com/uploads/5tpH95544We3gmijLiP7sL/__prompt____Ultra-photorealistic_portrait_of_202605241506.jpg" alt="Maestro Navy" className="w-full h-auto object-cover aspect-[4/5]" data-id="element-22" />
              <div className="absolute inset-0 bg-gradient-to-t from-mystic-black/80 via-mystic-black/20 to-transparent" data-id="element-23"></div>
              <div className="absolute bottom-6 left-6 right-6" data-id="element-24">
                <p className="font-serif text-2xl text-mystic-gold mb-1" data-id="element-25">
                  Maestro Navy
                </p>
                <p className="text-mystic-white/80 text-sm font-light" data-id="element-26">
                  Guía Espiritual y Terapeuta Energético
                </p>
              </div>
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} data-id="element-27">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-28">
              Conoce a tu{' '}
              <span className="text-gradient-gold" data-id="element-29">guía espiritual</span>
            </h2>

            <p className="text-lg text-mystic-white/80 mb-8 leading-relaxed font-light" data-id="element-30">
              Mi misión es ayudarte a encontrar claridad, equilibrio y
              respuestas mediante técnicas de percepción energética, fotomancia
              y armonización espiritual. Cada consulta es realizada con respeto,
              profesionalismo y absoluta confidencialidad.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-31">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4 + index * 0.1
            }} className="flex items-center gap-4 glass-panel px-4 py-3 rounded-xl" data-id="element-32">
                  <CheckCircle2 className="w-5 h-5 text-mystic-gold shrink-0" data-id="element-33" />
                  <span className="text-mystic-white/90 font-medium" data-id="element-34">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <WhatsAppButton text="Agendar consulta" variant="primary" message="Hola Maestro Navy, me gustaría agendar una consulta con usted." data-id="element-35" />
          </motion.div>
        </div>
      </div>
    </section>;
}